import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.CREATE_PACKAGE.REQUEST, saga.createPackage);
    yield takeEvery(ACTION.CREATE_PACKAGE.FAILED, saga.onCreatePackageFailed);
    yield takeEvery(ACTION.DELETE_PACKAGE.REQUEST, saga.removePackage);
}
